import React, { Component } from 'react'
import { appContext } from "../../../AppContext";
import IbssTextField from "../../Inputs/TextField/IbssTextField";
import { IVisitorChange, Visitor, VisitorField } from '../../Forms/Visitor/Visitor';

export default class VisitorTabView extends Component<IProps> {

    private get labels() { return appContext().labels; }

    private handleVisitorChange(props: IVisitorChange): void
    {
        if (props.firstName != undefined) { this.props.onFirstNameChange(props.firstName); }
        if (props.lastName != undefined) { this.props.onLastNameChange(props.lastName); }
        if (props.company != undefined) { this.props.onCompanyChange(props.company); }
        if (props.email != undefined) { this.props.onEmailChange(props.email); }
        if (props.visitorTypeId != undefined) { this.props.onVisitorTypeChange(props.visitorTypeId); }
    }

    public render(): JSX.Element
    {
        return (
            <>
                <div className="mt-1">
                    <label className="lable-modal">{this.labels.HubLabelNotMemberOfStaff}</label>
                </div>
                <Visitor
                    sx={{ padding: 0 }}
                    fields={VisitorField.Name | VisitorField.Company | VisitorField.Email | VisitorField.VisitorType}
                    buildingId={this.props.buildingId}
                    firstName={this.props.firstName}
                    lastName={this.props.lastName}
                    company={this.props.company}
                    email={this.props.email}
                    visitorTypeId={this.props.visitorTypeId}
                    onChange={e => this.handleVisitorChange(e)}
                    onValidate={e => this.props.onValidate(e)}
                />
            </>
        )
    }
}

export interface IProps
{
    buildingId: number;
    firstName: string;
    lastName: string;
    company: string;
    email: string;
    visitorTypeId: string;
    onFirstNameChange: (value: string) => void;
    onLastNameChange: (value: string) => void;
    onCompanyChange: (value: string) => void;
    onEmailChange: (value: string) => void;
    onVisitorTypeChange: (value: string) => void;
    onValidate: (isValid: boolean) => void;
}